"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
function setProgramDataTransferCredit(programData, json_data) {
    try {
        var newTotalCost = json_data.newTotalCost.toString().replace(/\$|\,/g, "");
        programData.registrationFee = parseFloat(json_data.newRegistrationFee.replace(/\$|\,/g, ""));
        programData.programTuition = parseFloat(json_data.newTuition.replace(/\$|\,/g, ""));
        programData.projectedGradDate = calculatProjectedGradDate(json_data.programStartDate, json_data.newProgramWeeks);
        programData.bookFees = parseFloat(json_data.newBookFees.replace(/\$|\,/g, ""));
        programData.programTermWeeks = json_data.newProgramWeeks;
        programData.totalCharges = parseFloat(newTotalCost);
        programData.estimatedTotalCharges = parseFloat(newTotalCost);
        programData.totalChargesObligated = parseFloat(newTotalCost);
        programData.academicQuarterCredits = json_data.newAcademicQCH;
        programData.clockHours = json_data.newClockHours;
        programData.transferPercentage = json_data.proRated;
        programData.courses = json_data.removedCourses;
        if (json_data.newSTRF) {
            programData.STRF = parseFloat(json_data.newSTRF.replace(/\$|\,/g, ""));
        }
    }
    catch (error) {
        throw {
            error: error,
            json_data: json_data
        };
    }
}
exports.setProgramDataTransferCredit = setProgramDataTransferCredit;
function calculatProjectedGradDate(programStartDate, weeks) {
    return moment_1.default(programStartDate).add(weeks, "weeks");
}
function getWeekHours(programData, json_data) {
    var weekHours = json_data["studentweeklyHours"];
    switch (weekHours) {
        case "12":
            return programData.weeks12Hours;
            break;
        case "18":
            return programData.weeks18Hours;
            break;
        case "24":
            return programData.weeks24Hours;
            break;
    }
}
function setProgramDataStandart(programData, json_data, campusState) {
    var programTermWeeks = getWeekHours(programData, json_data);
    programData.programTermWeeks = programTermWeeks;
    programData.projectedGradDate = calculatProjectedGradDate(json_data["programStartDate"], programTermWeeks);
    programData.bookFeesValue = programData.bookFees;
    if (json_data["includeBookFees"] != "Include") {
        programData.bookFees = 0;
    }
    if (campusState === "CA") {
        var subTotal = programData.registrationFee +
            programData.bookFees +
            programData.examFees +
            programData.programTuition;
        programData.STRF = Math.round(subTotal / 1000) * 2.5;
    }
    else {
        programData.STRF = 0;
    }
    programData.totalCharges =
        programData.STRF +
            programData.registrationFee +
            programData.bookFees +
            programData.examFees +
            programData.programTuition;
    programData.estimatedTotalCharges = programData.totalCharges;
    programData.totalChargesObligated = programData.totalCharges;
    programData.transferPercentage = "N/A";
    programData.courses = "N/A";
}
exports.setProgramDataStandart = setProgramDataStandart;
function getCampusState(campus) {
    switch (campus) {
        case "Sacramento":
            return "CA";
            break;
        case "Dallas":
            return "TX";
            break;
        case "Las Vegas":
            return "NV";
            break;
    }
}
exports.getCampusState = getCampusState;
//# sourceMappingURL=data:application/json;base64,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